import styled from 'styled-components';

import { ICardProps } from '@/components/Page';

import staffBgIcon from '@/images/staff/staffCard.svg';

import { backgroundImage, ellipsis, flex } from '@/styles/minix';
import { colorGroup } from '@/styles/common';

export const DisabledStaffWrap = styled.div<ICardProps>`
	${flex('row', 'flex-start')};
	flex-wrap: wrap;
	padding-bottom: 20px;
	.disabled--wrap {
		width: ${({ cardWidth }) => `${cardWidth}px`};
		height: ${({ cardHeight }) => `${cardHeight}px`};
		box-shadow: 0px 2px 6px 0px rgba(23, 43, 77, 0.06);
		border-radius: 4px;
		margin-left: ${({ cardLeft }) => `${cardLeft}px`};
		margin-top: ${({ cardTop }) => `${cardTop}px`};
		${backgroundImage(staffBgIcon)};
		background-size: 100%;
		box-sizing: border-box;
		padding: 16px 24px 12px 14px;

		${flex('column', 'flex-start', 'flex-start')}

		& .top--wrap {
			width: 100%;
			min-height: 76px;
			${flex('row', 'space-between', 'space-between')}

			& .left-wrap {
				& .name-major {
					${ellipsis()}
					font-size: 16px;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
					color: ${colorGroup.textImportant};
				}

				& .name-infior {
					${ellipsis()}
					color: ${colorGroup.textSlight};
				}
				& .mobile {
					color: ${colorGroup.textSlight};
					margin-top: 10px;
				}
			}
		}
		& .bottom--wrap {
			align-self: flex-end;
		}
	}
`;
